import { PostEditorReducerFunction, PostEditorUpdateProfilesAction } from '../PostEditorActions';
import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import { validatorStateUpdater } from '../../validators/helpers/validatorStateUpdater';
import { ErrorMessageSeverity } from '../../../../constants/form';
import { DisconnectedProfilesType } from '../../../../models/post-editor';
import { intersection } from 'lodash';

export const updateProfilesReducer: PostEditorReducerFunction<PostEditorUpdateProfilesAction['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, profiles } = payload;
  const newState = updateImmutable(state, {
    postGroups: {
      [postGroupIndex]: {
        profiles: {
          $set: profiles
        }
      }
    },
    disconnectedProfiles: {
      $apply: (currentProfiles: DisconnectedProfilesType[]) => {
        const disconnectedNotShown = currentProfiles.flatMap(profile => (profile.shown ? [] : profile.id));
        const profilesIds = profiles.map(profile => profile.profileId);
        const updateIntersection = intersection(profilesIds, disconnectedNotShown);
        if (!updateIntersection.length) return currentProfiles;
        return currentProfiles.map(p => (updateIntersection.includes(p.id) ? { ...p, selected: true } : p));
      }
    }
  });
  return validatorStateUpdater(newState, postGroupIndex, ErrorMessageSeverity.warning);
};
